import Reflux from "reflux";
export type Listenable = {
	readonly listen: (callback: (...args: any[]) => void) => () => void;
};
export type Subscription = {
	readonly stop: () => void;
	readonly listenable: Listenable;
};
export class Store {
	_store: any;
	_subscriptions: Subscription[];

	constructor() {
		//@ts-expect-error: createStore type-check is asking for argument but we don't have one
		this._store = Reflux.createStore();
		this._subscriptions = [];
	}

	listen(handler: () => void): () => void {
		return this._store.listen(handler);
	}

	listenTo(listenable: Listenable, callback): Subscription {
		// listenTo binds to the store instance by default, but that's not very useful for us here, so bind to this
		const subscription = this._store.listenTo(listenable, callback.bind(this));

		if (subscription) {
			this._subscriptions.push(subscription);
		}

		return subscription;
	}

	unhook() {
		for (const subscription of this._subscriptions) {
			subscription.stop();
		}

		this._subscriptions = [];
	}

	trigger(optAnything?: any) {
		this._store.trigger(optAnything);
	}
}
